module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/babel-runtime/core-js/symbol.js
// module id = 44
// module chunks = 0 1